import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import GenericActionBar from './GenericActionBar';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

import './index.css';

export default (element, store) => {
  let title;
  try {
    title = JSON.parse(element.dataset.title);
  } catch {
    title = element.dataset.title;
  }

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <GenericActionBar
            title={title}
            back={element.dataset.back && JSON.parse(element.dataset.back)}
            download={element.dataset.download && JSON.parse(element.dataset.download)}
            actions={element.dataset.actions && JSON.parse(element.dataset.actions)}
            transitions={element.dataset.transitions && JSON.parse(element.dataset.transitions)}
            commentsOnly={element.dataset.commentsOnly && JSON.parse(element.dataset.commentsOnly)}
            workflowId={element.dataset.workflowId}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
